import expressIcon from '../assets/images/expressicon.png';
import expressImg from '../assets/images/expressimg.png';
import akamaiIcon from '../assets/images/akamai.svg';

const devicon = (path) => `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${path}`;

// Icon grid. `category` is shown as a tag in the hover overview.
export const mainStack = [
	{ name: 'Ruby', category: 'language', icon: devicon('ruby/ruby-original.svg'), image: devicon('ruby/ruby-original-wordmark.svg') },
	{ name: 'Ruby on Rails', category: 'framework', icon: devicon('rails/rails-plain.svg'), image: devicon('rails/rails-original-wordmark.svg') },
	{ name: 'React', category: 'framework', icon: devicon('react/react-original.svg'), image: devicon('react/react-original-wordmark.svg') },
	{ name: 'Node.js', category: 'runtime', icon: devicon('nodejs/nodejs-original.svg'), image: devicon('nodejs/nodejs-original-wordmark.svg') },
	{ name: 'PostgreSQL', category: 'data', icon: devicon('postgresql/postgresql-original.svg'), image: devicon('postgresql/postgresql-original-wordmark.svg') },
	{ name: 'MongoDB / DocumentDB', category: 'data', icon: devicon('mongodb/mongodb-original.svg'), image: devicon('mongodb/mongodb-original-wordmark.svg') },
	// devicon dropped both AWS wordmark variants; the CDN answers 403 for them. Only
	// -line, -original and -plain still ship, so both handles point at -original.
	{ name: 'AWS', category: 'cloud', icon: devicon('amazonwebservices/amazonwebservices-original.svg'), image: devicon('amazonwebservices/amazonwebservices-original.svg') },
	{ name: 'Akamai Cloud (Linode)', category: 'cloud', icon: akamaiIcon, image: akamaiIcon },
	{ name: 'Kubernetes', category: 'devops', icon: devicon('kubernetes/kubernetes-plain.svg'), image: devicon('kubernetes/kubernetes-original-wordmark.svg') },
];

export const otherTools = [
	{ name: 'JavaScript', category: 'language', icon: devicon('javascript/javascript-original.svg'), image: devicon('javascript/javascript-original.svg') },
	{ name: 'Python', category: 'language', icon: devicon('python/python-original.svg'), image: devicon('python/python-original-wordmark.svg') },
	{ name: 'PHP', category: 'language', icon: devicon('php/php-original.svg'), image: devicon('php/php-original.svg') },
	{ name: 'Java', category: 'language', icon: devicon('java/java-original.svg'), image: devicon('java/java-original-wordmark.svg') },
	{ name: 'HTML', category: 'language', icon: devicon('html5/html5-original.svg'), image: devicon('html5/html5-original-wordmark.svg') },
	{ name: 'CSS', category: 'language', icon: devicon('css3/css3-original.svg'), image: devicon('css3/css3-original-wordmark.svg') },
	{ name: 'GraphQL', category: 'data', icon: devicon('graphql/graphql-plain.svg'), image: devicon('graphql/graphql-plain-wordmark.svg') },
	{ name: 'MySQL', category: 'data', icon: devicon('mysql/mysql-original.svg'), image: devicon('mysql/mysql-original-wordmark.svg') },
	{ name: 'Vue.js', category: 'framework', icon: devicon('vuejs/vuejs-original.svg'), image: devicon('vuejs/vuejs-original-wordmark.svg') },
	{ name: 'React Native', category: 'framework', icon: devicon('react/react-original.svg'), image: devicon('react/react-original.svg') },
	{ name: 'Express', category: 'framework', icon: expressIcon, image: expressImg },
	{ name: 'Docker', category: 'devops', icon: devicon('docker/docker-original.svg'), image: devicon('docker/docker-original-wordmark.svg') },
	{ name: 'ArgoCD', category: 'devops', icon: devicon('argocd/argocd-original.svg'), image: devicon('argocd/argocd-original-wordmark.svg') },
];

// The resume's skill groups, plus newer work not on the resume yet (AI / ML).
export const skillGroups = [
	{ name: 'Languages', items: ['Ruby', 'JavaScript', 'Python', 'PHP', 'Java', 'SQL', 'HTML/CSS'] },
	{ name: 'Frameworks', items: ['Ruby on Rails', 'React', 'React Native', 'Node.js', 'Express', 'Vue.js'] },
	{
		name: 'AI / ML',
		items: [
			'LLM integration (OpenAI GPT, Anthropic Claude, Amazon Bedrock Nova, Qwen, DeepSeek)',
			'LLM evaluation (labelled datasets, graders, LLM-as-judge)',
			'Retrieval-Augmented Generation (RAG)',
			'Vector search & embeddings',
			'Multi-agent orchestration',
			'Voice AI (OpenAI Realtime speech-to-speech, Twilio)',
			'Agentic software development (multi-agent Claude Code workflows)',
			'Prompt engineering',
		],
	},
	{ name: 'Data', items: ['PostgreSQL', 'MongoDB / Amazon DocumentDB', 'MySQL', 'GraphQL', 'REST APIs'] },
	{ name: 'Cloud & DevOps', items: ['AWS (EKS, ECR, RDS, Bedrock)', 'Kubernetes', 'Docker', 'ArgoCD (GitOps)', 'Git'] },
	{
		name: 'Integrations',
		items: ['Twilio Voice', 'Facebook Messenger Platform', 'Meta Pixel & Conversions API (CAPI)', 'Meta Marketing / Graph API'],
	},
];
